import { createSlice } from '@reduxjs/toolkit';
// import produce from 'immer';
import {
  NOTSET_ENV,
} from '../common/constants';
import logger from '../common/logger';

export const envSlice = createSlice({
  name: 'envData',
  initialState: {
    ENVIRONMENT: NOTSET_ENV,
    LMS_HEADERS: { },
  },
  extraReducers: (builder) => {
    logger.log(builder);
  },
});

export default envSlice.reducer;
